import React, {useState} from 'react';
import useMerchantPortalAxios from "../utils/axios";
function useEodClosing() {
    const [closingTransactions, setClosingTransactions] = useState(null);
    const [transactionsLoading, setTransactionsLoading] = useState(false);
    const [totalNbOfPage, setTotalNbOfPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    const [trxDetails, setTrxDetails] = useState(null);
    const [detailsLoading, setDetailsLoading] = useState(false);

    const MerchantPortalClient = useMerchantPortalAxios();

    const GetEODClosingTransactions = async (page) => {
        const pageSize = 10;
        setTransactionsLoading(true);
        const res = await MerchantPortalClient.post(
            `/v1/EODClosing/GetEODClosingTransactions`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                page: page,
                pageSize: pageSize
            }
        ).then((res) => {
            setClosingTransactions(res.data.Payload.EODTrxs);
            setTotalNbOfPage(res.data?.Payload?.EODTrxs[0].TotalPages || 0);
            setTotalCount(res.data?.Payload?.EODTrxs[0].TotalCount || 0)
        }).finally(()=>{
            setTransactionsLoading(false);
        });

    }

    const GetEODClosingTrxDetails = async (transactionId)=>{
        setDetailsLoading(true);
        const res = await MerchantPortalClient.post(
            `/v1/EODClosing/GetEODClosingTrxDetails`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                TransactionID: transactionId
            }
        ).then((res) => {
            setTrxDetails(res.data.Payload);
            setDetailsLoading(false);
        });
    }

    return {
        GetEODClosingTransactions,
        GetEODClosingTrxDetails,
        closingTransactions,
        transactionsLoading,
        totalNbOfPage,
        totalCount,
        trxDetails,
        detailsLoading
    }
}

export default useEodClosing;